import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './NewCreditCard.styles';
import {
  Button, Checkbox, IconSecurity, SelectField, Skeleton,
} from 'gatorcomponents';
import PropTypes from 'prop-types';
import { isBRServer } from '@/utils/Validators/validation';

const NewCreditCard = ({
  invoice,
  saveCcButtonLabel,
  bottomMessage,
  loadingCreditCardInstallments,
  selectInstallmentsPlaceholder,
  useOnNextRenovationLabel,
  existsCreditCard,
  replaceCardLabel,
  installmentsOptions,
  isButtonLoading,
  isCcButtonEnabled,
  canSubmit,
  renderIframe,
  submitCreditCard,
  setInstallment,
  setUseOnNextRenovation,
}) => {
  const [useCardOnNextRenovation, setUseCardOnNextRenovation] = useState(false);
  const [selectedInstallment, setSelectedInstallment] = useState(null);

  const showRenovationCheckbox = invoice && invoice.showCreditCardCheckbox;

  const handleUseCardOnNextRenovation = () => {
    setUseCardOnNextRenovation(!useCardOnNextRenovation);
    setUseOnNextRenovation && setUseOnNextRenovation(!useCardOnNextRenovation);
  };

  const handleSetSelectedInstallment = useCallback((option) => {
    setSelectedInstallment(option);
    setInstallment && setInstallment(option);
  }, [setInstallment]);

  const setFirstOptionAsDefault = useCallback(() => {
    if (!isBRServer && installmentsOptions.length > 0) {
      handleSetSelectedInstallment(installmentsOptions[0]);
    }
  }, [installmentsOptions, handleSetSelectedInstallment]);

  useEffect(() => {
    setFirstOptionAsDefault();
  }, [setFirstOptionAsDefault]);

  const isDisabled = (!isCcButtonEnabled && !canSubmit) || isButtonLoading || !selectedInstallment;

  return (
    <Styles.Wrapper>
      {existsCreditCard && (
        <Styles.ReplaceOtherCardText>
          {replaceCardLabel}
        </Styles.ReplaceOtherCardText>
      )}
      <Styles.PaymentInfos>
        {renderIframe}

        {isBRServer && (
          <Styles.SelectContainer>
            {!loadingCreditCardInstallments && (
              <SelectField
                withScroll
                value={selectedInstallment && selectedInstallment.label}
                options={installmentsOptions}
                placeholder={selectInstallmentsPlaceholder}
                onClickSelect={handleSetSelectedInstallment}
              />
            )}
            {loadingCreditCardInstallments && <Skeleton width="380px" height="60px" />}
          </Styles.SelectContainer>
        )}

      </Styles.PaymentInfos>
      {showRenovationCheckbox && (
        <Styles.CheckboxContainer onClick={handleUseCardOnNextRenovation}>
          <Checkbox checked={useCardOnNextRenovation} />
          {useOnNextRenovationLabel}
        </Styles.CheckboxContainer>
      )}
      <Button
        label={saveCcButtonLabel}
        size="large"
        onClick={submitCreditCard}
        loading={isButtonLoading}
        disabled={isDisabled}
      />
      <Styles.BottomMessage>
        <IconSecurity size="sm" color="primaryExtraDark" />
        <Styles.BottomMessageText>
          {bottomMessage}
        </Styles.BottomMessageText>
      </Styles.BottomMessage>
    </Styles.Wrapper>
  );
};

NewCreditCard.propTypes = {
  invoice: PropTypes.object,
  saveCcButtonLabel: PropTypes.string,
  bottomMessage: PropTypes.string,
  loadingCreditCardInstallments: PropTypes.bool,
  selectInstallmentsPlaceholder: PropTypes.string,
  useOnNextRenovationLabel: PropTypes.string,
  existsCreditCard: PropTypes.bool,
  replaceCardLabel: PropTypes.string,
  installmentsOptions: PropTypes.array,
  isButtonLoading: PropTypes.bool,
  isCcButtonEnabled: PropTypes.bool,
  canSubmit: PropTypes.bool,
  renderIframe: PropTypes.element,
  submitCreditCard: PropTypes.func,
  setInstallment: PropTypes.func,
  setUseOnNextRenovation: PropTypes.func,
};


export default NewCreditCard;
